import { forwardRef } from 'react';
import cn from '../../app/utils/cn';

interface IProgressBarProps {
  value: number;
  showLabel?: boolean;
  className?: string;
}

const ProgressBar = forwardRef<HTMLDivElement, IProgressBarProps>(
  ({ value, showLabel = true, className }, ref) => {
    const clamped = Math.min(100, Math.max(0, value));

    return (
      <div ref={ref} className={cn('flex items-center gap-2', className)}>
        <div className="bg-surface-input dark:bg-grey-700 h-2 flex-1 overflow-hidden rounded-full">
          <div
            className="h-full rounded-full bg-green-600 transition-all duration-300 dark:bg-green-400"
            style={{ width: `${clamped}%` }}
          />
        </div>
        {showLabel && (
          <span className="text-text-tertiary min-w-[2.5rem] text-right text-xs">
            {clamped}%
          </span>
        )}
      </div>
    );
  },
);

ProgressBar.displayName = 'ProgressBar';

export default ProgressBar;
